/**
 * 하이라이트 조각(`toHighlightSegments`)을 React 노드로 그린다 — `HighlightedText` 와 `SafeHtml` 의 서버 그림이 함께 쓴다.
 *
 * React 는 텍스트를 언제나 escape 하므로, 세척을 지나지 않은 문자열의 조각이라도 이 자리에서 태그가 만들어질 수 없다.
 * ⚠️ 강조 스타일은 하이라이터가 만든 인라인 문자열을 그대로 옮긴다 — 색을 여기서 다시 정하면 본문 갈래와 갈린다.
 */

import type { HighlightSegment } from 'src/utils/text/highlight-segments';

// ----------------------------------------------------------------------

/** 하이라이터가 넣는 인라인 스타일 문자열 → React style 객체 */
function toStyleObject(style: string | null): React.CSSProperties | undefined {
  if (!style) return undefined;
  const out: Record<string, string> = {};
  style.split(';').forEach((decl) => {
    const idx = decl.indexOf(':');
    if (idx < 0) return;
    const prop = decl.slice(0, idx).trim();
    const value = decl.slice(idx + 1).trim();
    if (!prop || !value) return;
    // `background-color` → `backgroundColor`
    const camel = prop.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
    out[camel] = value;
  });
  return Object.keys(out).length > 0 ? (out as React.CSSProperties) : undefined;
}

export function HighlightSegmentNodes({ segments }: { segments: readonly HighlightSegment[] }) {
  return (
    <>
      {segments.map((seg, i) => {
        const key = `${i}-${seg.tag ?? 'plain'}`;
        if (seg.tag === 'mark') {
          return <mark key={key} style={toStyleObject(seg.style)}>{seg.text}</mark>;
        }
        if (seg.tag === 'span') {
          return <span key={key} style={toStyleObject(seg.style)}>{seg.text}</span>;
        }
        return <span key={key}>{seg.text}</span>;
      })}
    </>
  );
}
